import React, { useEffect, useState } from "react";
import { Pagination, PaginationProps, Tooltip } from "antd";
import DynamicTable from "../../../components/CommonTable/DynamicTable";
import { ErrorMessages, useGetApiRequests } from "../../../common/CommonExport";
import DeleteConfirmationModal from "../DeleteConfirmationModal";
import { TRFColumns } from "../TableColumn";
import PopupModal from "../../employee/employee-details/employee-profile/modal/PopupModal";
import TRFUpdateModal from "./Modal/TRFUpdateModal";
import { capitalizeFirstLetter, handleDeleteTrf } from "./Modal/TRFHelper";
import dayjs from "dayjs";
import TRFFilter from "./TRFFilter";
import { useSelector } from "react-redux";

const TRFList: React.FC = () => {
    const deleteTRF = useGetApiRequests("trfForm", "DELETE");
    const trfFormApi = useGetApiRequests("trfForm", "POST");
    const [designation, setDesignation] = useState([]);
    const [deletePopUp, setDeletePopUp] = useState(false);
    const [selectedRows, setSelectedRows]: any = useState([]);
    const [updateModal, setUpdateModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [editRecord, setEditRecord] = useState({});
    const [deleteMessage, setDeleteMessage] = useState("");
    const [isSingleDelete, setIsSingleDelete] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [loader, setLoader] = useState(false);
    const [count, setCount] = useState<number>();
    const [modalErrMessage, setModalErrMessage] = useState("");
    const [popModal, setPopModal] = useState(false);
    const [modalResponse, setModalResponse] = useState("");
    const [modalButtonShow, setModalButtonShow] = useState(true);
    const [searchQuery, setSearchQuery] = useState<any>({
        createdByName: "",
        designationName: "",
        jobType: "",
        status: "",
    });
    const orgId = useSelector((state: any) => state?.organisationId?.id);
    const onShowSizeChange: PaginationProps["onShowSizeChange"] = (current, size) => {
        setCurrentPage(1);
        setPageSize(size);
    };
    const handleEditRow = (record: any) => {
        setIsEdit(true);
        setUpdateModal(true);
        setEditRecord(record);
    };
    const handleSingleDelete = (record: any) => {
        setDeletePopUp(true);
        setIsSingleDelete(true);
        const recordArray: any = [];
        recordArray.push(record);
        setSelectedRows(recordArray);
        setDeleteMessage(`Are you sure you want to delete this TRF?`);
    };
    const handleClosePopUpModal = () => {
        setPopModal(false);
    };
    const columns = [
        ...TRFColumns,
        {
            title: "Action",
            dataIndex: "deleteButton, editButton",
            render: (_: any, record: any) => (
                <div className="flex">
                    <Tooltip placement="top" title="Edit">
                        <span className="material-symbols-outlined mr-4 cursor-pointer hover:text-primary" onClick={() => handleEditRow(record)}>
                            edit
                        </span>
                    </Tooltip>
                    <Tooltip placement="top" title="Delete">
                        <span className="material-symbols-outlined mr-4 cursor-pointer hover:text-primary" onClick={() => handleSingleDelete(record)}>
                            delete
                        </span>
                    </Tooltip>
                </div>
            ),
        },
    ];

    const resetTable = () => {
        setCurrentPage(1)
        setPageSize(10)
    }
    const designationGetApi = (searchQuery: any, type: string = "") => {
        setLoader(true);
        const start: number = currentPage > 1 ? currentPage - 1 : 0;
        let startSize = 0
        if (type === "filter") {
            startSize = 0
            resetTable()
        }
        else {
            startSize = start * pageSize
        }

        const payload = {
            searchTrfDto: {
                createdByName: searchQuery?.createdByName ? searchQuery.createdByName : undefined,
                designationName: searchQuery?.designationName ? searchQuery.designationName : undefined,
                jobType: searchQuery?.jobType ? searchQuery.jobType : undefined,
                status: searchQuery?.status ? searchQuery.status : undefined,
                organisationId: orgId,
            },
            start: startSize,
            limit: pageSize,
            sortBy: "talentRequisitionFormId",
            sortDirection: "DESC"
        };

        const pathParams = {
            path: "range",
        };
        trfFormApi(payload, {}, pathParams)
            .then((response: any) => {
                const reformedDesignation = response?.data?.data.map((item: any, index: number) => ({
                    employeeName: item?.createdBy?.firstName + " " + item?.createdBy?.lastName,
                    designation: item?.designation?.name,
                    designationId: item?.designation?.designationId,
                    jobType: item?.jobType ? capitalizeFirstLetter(item?.jobType?.replace(/_/g, " ")?.toLowerCase()) : "",
                    department: item?.designation?.departmentName,
                    departmentId: item?.department?.departmentId,
                    status: item?.status ? capitalizeFirstLetter(item?.status?.replace(/_/g, " ")?.toLowerCase()) : "",
                    key: item?.talentRequisitionFormId,
                    deadline: item?.expectedDateOfJoining ? dayjs(item?.expectedDateOfJoining)?.format("YYYY-MM-DD") : "",
                }));
                setDesignation(reformedDesignation);
                setCount(response?.data?.meta?.totalRecords);
                setTimeout(() => {
                    setLoader(false);
                }, 1000);
            })
            .catch((err: any) => {
                setPopModal(true);
                setModalButtonShow(false);
                setModalErrMessage(ErrorMessages.somethingWentWrong);
                setModalResponse("error");
                setTimeout(() => {
                    handleClosePopUpModal();
                    setLoader(false);
                }, 1500);
            });
    };

    useEffect(() => {
        const designationTag: any = document.getElementsByClassName("ant-table-content");
        designationTag[1].scrollTop = 0;
        designationGetApi(searchQuery);
    }, [currentPage, pageSize]);

    const handleSelectedRows = (selected: any) => {
        setSelectedRows(selected);
        setDeleteMessage(`Are you sure you want to delete these (${selected.length}) TRF?`);
    };
    const handleCloseDelete = () => {
        setDeletePopUp(false);
        setIsSingleDelete(false);
    };
    const handleDeleteSelected = async () => {
        // CALL API IF NEEDED
        setSelectedRows([]);
    };
    const handleSingleSelectDelete = async (record: any) => {
        const deleteArray: any = [];
        setDeletePopUp(false);
        const id = selectedRows[0].key;
        deleteArray.push(id);
        setSelectedRows([]);
        handleDeleteTrf({ deleteTRF, deleteArray, setModalErrMessage, setModalResponse, handleClosePopUpModal, designationGetApi, searchQuery, setPopModal });
    };

    // const handelDesignationPopUp = () => {
    //     setUpdateModal(true);
    //     setIsEdit(false);
    // };
    const handleClose = () => {
        setIsEdit(false);
        setUpdateModal(false);
    };

    const handleClear = () => {
        const searchQuery = {
            createdByName: "",
            designationName: "",
            jobType: "",
            status: "",
        };
        setSearchQuery(searchQuery);
        designationGetApi(searchQuery);
    };
    const handleSubmit = () => {
        designationGetApi(searchQuery, "filter");
    };

    return (
        <div className="organization-table">
            <TRFFilter searchQuery={searchQuery} setSearchQuery={setSearchQuery} handleClear={handleClear} handleSubmit={handleSubmit} />
            <DynamicTable isRowSelection={false} columns={columns} data={designation} handleSelectedRows={handleSelectedRows} loading={loader} />
            <div className="pagination text-right px-6 pt-6">
                <Pagination
                    className="float-right flex flex-row ml-2"
                    showSizeChanger
                    onShowSizeChange={onShowSizeChange}
                    defaultCurrent={1}
                    current={currentPage}
                    total={count}
                    pageSize={pageSize}
                    onChange={(page) => setCurrentPage(page)}
                />
            </div>
            {deletePopUp && (
                <DeleteConfirmationModal
                    open={deletePopUp}
                    handleSingleSelectDelete={handleSingleSelectDelete}
                    handleDeleteSelected={handleDeleteSelected}
                    handleCloseDelete={handleCloseDelete}
                    selectedRows={selectedRows}
                    type="designation"
                    isSingleDelete={isSingleDelete}
                    deleteMessage={deleteMessage}
                />
            )}
            {updateModal && <TRFUpdateModal isEdit={isEdit} designationGetApi={designationGetApi} searchQuery={searchQuery} open={updateModal} handleClose={handleClose} editRecord={editRecord} />}
            {popModal && <PopupModal message={modalErrMessage} open={popModal} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={modalButtonShow} />}
        </div>
    );
};
export default TRFList;
